import React from "react";
import { capitalize } from "../../utils/textFunctions";

const Gender = ({ data, summary: isSummary, extensions: extensions }) => {
  if (isSummary) {
    const sourceCode = extensions
      ? extensions.filter(e => e.url.includes("genderSrcCode"))
      : "";
    return (
      <div>
        Gender: {capitalize(data)}{" "}
        {sourceCode[0] ? "[" + sourceCode[0].valueString + "]" : ""}
      </div>
    );
  }
  return (
    <div>
      <h4>Gender</h4>
      <div>{capitalize(data)}</div>
    </div>
  );
};

export default Gender;
